import http from "../api/http";
import { api } from "../api/environment";
import { ServerResponse, IProduct } from "../types/global";

const getAll = (
  maxResultCount: number,
  skipCount?: number,
  search?: string
) => {
  return http.get<ServerResponse<IProduct>>(
    `/services/app${api.PRODUCT_SERVICE}/GetAll?${
      maxResultCount ? "MaxResultCount=" + maxResultCount + "&" : ""
    }${skipCount ? "SkipCount=" + skipCount + "&" : ""}${
      search ? "Search=" + search + "&" : ""
    }`
  );
};

const get = (id: number) => {
  return http.get<IProduct>(`/services/app${api.PRODUCT_SERVICE}/Get?Id=${id}`);
};

const create = (payload: IProduct) => {
  return http.post(`/services/app${api.PRODUCT_SERVICE}/Create`, payload);
};

const remove = (id: number) => {
  return http.delete<IProduct>(
    `/services/app${api.PRODUCT_SERVICE}/Delete?Id=${id}`
  );
};

const put = (payload: IProduct) => {
  return http.put(`/services/app${api.PRODUCT_SERVICE}/Update`, payload);
};

export const productService = { getAll, get, create, remove, put };
